import React, {Component} from 'react';
import './asset-structure.style.scss';
import {Cell, Label, Legend, Pie, PieChart, ResponsiveContainer, Tooltip} from 'recharts';
import pie from 'assets/icons/pie-icon.svg';

function CustomLabel({viewBox, value}) {
  const {cx, cy} = viewBox;
  return (
    <svg className='recharts-text recharts-label' textAnchor='middle' dominantBaseline='central'>
      <text x={cx} y={cy}>
        <tspan
          x={cx}
          dy='0em'
          alignmentBaseline='middle'
          fontSize='20'
          fill='#0B0B0A'
          fontWeight={600}>
          {value}
        </tspan>
      </text>
    </svg>
  );
}

export default class AssetStructure extends Component {
  render() {
    const data = [
      {name: 'Interbank', key: 'i', value: 8},
      {name: 'Loan', key: 'l', value: 49},
      {name: 'Investment Sercurities', key: 'is', value: 18},
      {name: 'Other Asset', key: 'ot', value: 25},
    ];
    const COLORS = ['#FDE39B', '#FBC83A', '#C89404', '#644A02'];
    return (
      <div className='asset-structure-container'>
        <h1 className='asset-structure-title'>
          <img src={pie} alt='' style={{marginRight: 8}} />
          ASSET STRUCTURE
        </h1>
        <ResponsiveContainer width='100%' height={250}>
          <PieChart>
            <Pie
              paddingAngle={0}
              data={data}
              dataKey='value'
              cx='50%'
              cy='50%'
              outerRadius={125}
              innerRadius={85}
              startAngle={90}
              endAngle={-450}>
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                  borderWidth={0}
                  stroke={0}
                />
              ))}
              <Label width={80} position='center' content={<CustomLabel value={'181,438'} />} />
            </Pie>
            <Tooltip cursor={false} content={<CustomTooltip data={data} colors={COLORS} />} />
            <Legend
              layout='vertical'
              align='right'
              verticalAlign='middle'
              formatter={(value, entry) => {
                const {payload} = entry;
                return (
                  <span style={{color: '#0B0B0A', fontSize: 14}}>
                    {value}
                    {'  '}
                    <span style={{color: '#0B0B0A', fontSize: 14, fontWeight: 600}}>
                      {payload.value}%
                    </span>
                  </span>
                );
              }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

const CustomTooltip = (props) => {
  const {active, payload, data, colors} = props;

  if (active && payload && payload.length) {
    const item = payload[0].payload;
    const index = data.findIndex((el) => el.key === item.key);

    return (
      <div className='custom-tooltip' style={{backgroundColor: colors[index % data.length]}}>
        <span className='name'>{item.name}</span>
        <span className='desc'>{item.value}%</span>
      </div>
    );
  }

  return null;
};



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/components/AssetStructure/AssetStructure.js